module.exports = __webpack_public_path__ + "img/Verified.d1db2a12.png";